import { Stack, SxProps, Theme, Typography } from '@mui/material'
import { useMinimalsTheme } from '../../../hooks'
import { ColorSchema } from '../../palette'

interface Props {
  label?: string
  color: ColorSchema
  startIcon?: React.ReactElement
  endIcon?: React.ReactElement
  sx?: SxProps<Theme>
  dataCy?: string
}
export const ColoredLabel = ({
  label,
  color,
  startIcon,
  endIcon,
  sx,
  dataCy = 'colored-label-label',
}: Props) => {
  const theme = useMinimalsTheme()
  return (
    <Stack
      gap={theme.customSpacing.xxs}
      direction={'row'}
      alignItems={'center'}
      sx={{
        backgroundColor: theme.palette[color].lighter,
        color: theme.palette[color].dark,
        padding: `${theme.customSpacing.xxs} ${theme.customSpacing.xs}`,
        borderRadius: theme.customRadius.small,
        ...sx,
      }}
    >
      {startIcon}
      {label && (
        <Typography variant='captionBold' data-cy={dataCy}>
          {label}
        </Typography>
      )}
      {endIcon}
    </Stack>
  )
}
